function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FEEDBACK_CONTENT, THEME } from "./constants";
import FormDetails from "./FormDetails";
import ConfirmationDetails from "./ConfirmationDetails";
import { ReportDialogPropTypes } from "./ReportDialogProps";
import "../assets/sentry-error.css";

const ReportDialog = ({
  onSubmit,
  onClose,
  options
}) => {
  const [contentType, setContentType] = React.useState(FEEDBACK_CONTENT.DETAILS);
  const onHandleSubmit = React.useCallback(async values => {
    try {
      const result = await onSubmit(values);
      setContentType(FEEDBACK_CONTENT.THANKS);
      return result;
    } catch (e) {
      setContentType(FEEDBACK_CONTENT.SORRY);
    }
  }, [onSubmit, setContentType]);
  React.useEffect(() => {
    options.onLoad && options.onLoad();
  });
  const content = React.useMemo(() => {
    switch (contentType) {
      case FEEDBACK_CONTENT.THANKS:
        return /*#__PURE__*/React.createElement(ConfirmationDetails, {
          onClose: onClose,
          message: options.successMessage,
          imageSrc: require("../assets/Happy.png")
        });

      case FEEDBACK_CONTENT.SORRY:
        return /*#__PURE__*/React.createElement(ConfirmationDetails, {
          onClose: onClose,
          message: options.errorGeneric,
          imageSrc: require("../assets/Sad.png")
        });

      default:
        {
          return /*#__PURE__*/React.createElement(FormDetails, _extends({}, options, {
            onSubmit: onHandleSubmit,
            onClose: onClose
          }));
        }
    }
  }, [contentType, onClose, onHandleSubmit, options]);
  return /*#__PURE__*/React.createElement("div", {
    className: "sentry-error-embed-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("sentry-error-embed", "clearfix", options.theme === THEME.DARK && "dark")
  }, content));
};

ReportDialog.propTypes = {
  containerClassName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  options: PropTypes.shape(ReportDialogPropTypes)
};
export default ReportDialog;